import { Button, ButtonProps } from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import { LinkProps, Link as ReactRouterLink } from "react-router-dom"
import Pathicon from "../../../pathicon/Pathicon"

export type SimpleButtonProps = {
  to?: LinkProps["to"]
  icon?: IconName
  leftIcon?: IconName
  rightIcon?: IconName
  label?: string
} & Omit<ButtonProps, "leftIcon" | "rightIcon">

const SimpleButton = ({
  to,
  icon,
  leftIcon,
  rightIcon,
  label,
  ...buttonProps
}: SimpleButtonProps) => {
  rightIcon = rightIcon || icon

  return (
    <Button
      as={to ? ReactRouterLink : "button"}
      to={to}
      colorScheme="whiteAlpha"
      size="sm"
      textDecor="none"
      leftIcon={leftIcon ? <Pathicon icon={leftIcon} /> : undefined}
      rightIcon={rightIcon ? <Pathicon icon={rightIcon} /> : undefined}
      backdropFilter="auto"
      backdropBlur="8px"
      iconSpacing={1}
      sx={{
        // Yikes: very specificly pulling in the edge of the button for the chevron left/right icons
        // for aesthetic appeal (visually, the spacing past the icon looks exsessive for this icon).
        ".chakra-button__icon": {
          ml: leftIcon === "chevron-left" ? -1 : undefined,
          mr: rightIcon === "chevron-right" ? -1 : undefined
        }
      }}
      {...buttonProps}
    >
      {label || buttonProps.children}
    </Button>
  )
}

export default SimpleButton
